import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleStartDiscussion(
  state: State,
  { discussion, project }: Boundaries["startDiscussion"]["success"],
): State {
  const index = state.findIndex((req) => req.project.uuid === project.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          discussions: [discussion, ...state[index].discussions],
        },
        ...state.slice(index + 1),
      ]
    : state;
}

export { handleStartDiscussion };
